// Types
import { IPaginatedResponse } from "@/Common/api/types/pagination";
// Hooks
import { InfiniteData, useInfiniteQuery, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { useMemo } from "react";
// Helpers
import { buildGetNextPageParam, getAllPaginatedData } from "./helpers";

interface IUsePaginatedResourceConfiguration<T, TExtraData>
	extends UseInfiniteQueryOptions<IPaginatedResponse<T, TExtraData>, Error, InfiniteData<IPaginatedResponse<T, TExtraData>>> {
	fetchAllPages?: boolean;
}

export const usePaginatedResource = <T, TExtraData>(configuration: IUsePaginatedResourceConfiguration<T, TExtraData>) => {
	const { fetchAllPages, ...infiniteQueryConfiguration } = configuration;

	const infiniteQueryResult = useInfiniteQuery({
		...infiniteQueryConfiguration,
		getNextPageParam: configuration.getNextPageParam ?? buildGetNextPageParam(),
	});

	const data = useMemo(() => getAllPaginatedData(infiniteQueryResult.data), [infiniteQueryResult.data]);

	if (fetchAllPages && !infiniteQueryResult.isFetching && !infiniteQueryResult.isLoading && infiniteQueryResult.hasNextPage) {
		infiniteQueryResult.fetchNextPage({ cancelRefetch: false });
	}

	return { ...infiniteQueryResult, paginatedData: infiniteQueryResult.data, data };
};
